import { LDFlagSet } from "launchdarkly-js-client-sdk";
import { useFlags } from "launchdarkly-react-client-sdk";
import { generatePath } from "react-router";

import { useConfigContext } from "shared/contexts/ConfigContext";
import { EventTypeEnum } from "shared/types";

import { PagesConfigModel } from "pages/SuperAdmin/PagesConfig/types";

import Link from "features/ui/Link";

import { routes } from "services/routes";

interface DetailsLinkForEventTypeProps {
  ID: string;
  type: EventTypeEnum;
}

const DetailsLinkForEventType = ({
  type,
  ID,
}: DetailsLinkForEventTypeProps) => {
  const flags = useFlags();
  const { pages } = useConfigContext();
  const linkForType = getLinkForType(type, ID, flags, pages);

  if (!linkForType) {
    return <>{ID}</>;
  }

  return <Link to={linkForType}>{ID}</Link>;
};

const getLinkForType = (
  type: string,
  ID: string,
  flags: LDFlagSet,
  pages: PagesConfigModel
): string | undefined => {
  switch (type) {
    case EventTypeEnum.CLAIM:
      return (
        flags.claimAnalytics &&
        pages.claimAnalytics &&
        generatePath(routes.claimAnalyticsDetails, {
          id: ID,
        })
      );
    case EventTypeEnum.INSPECTION:
      return (
        flags.inspectionAnalytics &&
        pages.inspectionAnalytics &&
        generatePath(routes.inspectionAnalyticsDetails, {
          id: ID,
        })
      );
    case EventTypeEnum.REPAIR:
      return (
        flags.repairAnalytics &&
        pages.repairAnalytics &&
        generatePath(routes.repairAnalyticsDetails, {
          id: ID,
        })
      );
    default:
      return;
  }
};

export default DetailsLinkForEventType;
